import React from "react";

import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { listDepot, getpdf, telechargerPDF } from "../../actions/depotActions";
import { useNavigate, useParams } from "react-router-dom";

import PDF from "../../components/Pdf";

import Navbar2 from "../../components/navbars/Navbar2";
import Message from "../../components/Message";
import CircularProgress from "@mui/material/CircularProgress";
import { PDF_RESET } from "../../constants/depot_constant";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { Divider } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

// icon
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CheckIcon from "@mui/icons-material/Check";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { styled } from "@mui/material/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import { orange } from "@mui/material/colors";
import { green } from "@mui/material/colors";
import { grey } from "@mui/material/colors";

const Resultat = () => {
  const dispatch = useDispatch();

  let {
    id_depot,
    saisie,
    valid,
    depot_analyse_valid,
    reste,
    tous_signee,
    reste_p_auto_print,
    auto_print_reste_p,
  } = useParams();
  const pdfPage = useSelector((state) => state.pdfPage);
  const { pdf } = pdfPage;

  const [pdfpageNotification, setpdfpageNotification] = useState();
  const [askDepotId, setaskDepotId] = useState();

  useEffect(() => {
    askIdDepot(
      id_depot,
      saisie,
      valid,
      depot_analyse_valid,
      reste,
      tous_signee,
      reste_p_auto_print,
      auto_print_reste_p
    );
  }, []);

  const askIdDepot = (
    id,
    saisie,
    valide,
    depot_valide,
    reste,
    paramValide,
    restAutorise,
    autoriseRest
  ) => {
    // console.log("askIdDepot function", id);
    if (saisie === "N" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossie non saisi");
    } else if (saisie === "P" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier Partiellement saisi");
    } else if (valide === "N" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier non validé techniquement");
    } else if (valide === "P" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier Partiellement validé");
    } else if (
      depot_valide === "N" &&
      restAutorise !== "O" &&
      autoriseRest !== "O"
    ) {
      setpdfpageNotification(" Dossier non signé");
    } else if (!paramValide && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier Pariellement signé");
    } else if (reste != 0 && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("pour voir le résultat veuillez payer la facture");
    } else {
      setpdfpageNotification(false);
    }
    dispatch(getpdf(id));
    setaskDepotId(id);
  };

  return (
    <Grid item md={8} xs={12}>
      <Divider sx={{ marginY: 1 }}>
        <Chip label="Résultat à visualiser" />
      </Divider>
      <Box sx={{ display: "flex", justifyContent: "end ", mb: 1 }}>
        <Button
          color="success"
          variant="contained"
          //   href={
          //     "http://" +
          //     window.location.hostname +
          //     "/core/pdfPatient.php?id=" +
          //     askDepotId
          //   }
          target="_blank"
          // onClick={(e) => printPdf(askDepotId)}
          startIcon={<DownloadForOfflineIcon />}
        >
          Télécharge les résultats
        </Button>
      </Box>
      <Paper>
        <Box
          sx={{
            p: 6,
            mb: 2,
            height: 500,
            maxHeight: 500,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            overflowY: "scroll",
            bgcolor: "#fff",
            boxShadow: 5,
          }}
        >
          {!pdfpageNotification ? (
            <PDF pdf={pdf} />
          ) : (
            <Message variant="error">{pdfpageNotification}</Message>
          )}
        </Box>
      </Paper>
    </Grid>
  );
};

export default Resultat;
